"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RequestException = exports.NotFoundException = void 0;

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var NotFoundException = /*#__PURE__*/_createClass(function NotFoundException(message) {
  _classCallCheck(this, NotFoundException);

  this.name = 'NotFound';
  this.message = message;
  this.stack = new Error().stack;
});

exports.NotFoundException = NotFoundException;

var RequestException = /*#__PURE__*/_createClass(function RequestException(status, message) {
  _classCallCheck(this, RequestException);

  this.name = 'RequestException';
  this.status = status;
  this.message = message;
  this.stack = new Error().stack;
});

exports.RequestException = RequestException;


//////////////////
// WEBPACK FOOTER
// ./~/global-components-library/dist/util/exceptions.js
// module id = 1939
// module chunks = 0